(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-info-shapes-link"] && !Shopify.designMode) return;
  try {
    if (!window.__productInfoShapesLinkBound) {
    window.__productInfoShapesLinkBound = true;

    const syncShapesLinks = () => {
      const section = document.getElementById('different-shapes');

      document.querySelectorAll('.product-info-shapes-link').forEach((el) => {
        if (el.hasAttribute('data-shapes-editor')) return;

        if (section) {
          el.hidden = false;
        } else {
          el.remove();
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncShapesLinks, { once: true });
    } else {
      syncShapesLinks();
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-info-accordion"] && !Shopify.designMode) return;
  try {
    const SHAPE_MS = 80;
  const COLLAPSE_MS = 280;

  if (!window.__productInfoAccordionBound) {
    window.__productInfoAccordionBound = true;

    document.addEventListener('click', (event) => {
      const summary =
        event.target instanceof Element ? event.target.closest('.product-info-accordion__summary') : null;

      if (!summary) return;

      const details = summary.closest('details.product-info-accordion__item');
      if (!(details instanceof HTMLDetailsElement)) return;

      event.preventDefault();

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (details.open) {
        details.open = false;

        if (reduceMotion) {
          details.classList.remove('is-shaped');
          return;
        }

        window.setTimeout(() => {
          if (!details.open) details.classList.remove('is-shaped');
        }, COLLAPSE_MS);
        return;
      }

      details.classList.add('is-shaped');

      if (reduceMotion) {
        details.open = true;
        return;
      }

      window.setTimeout(() => {
        details.open = true;
      }, SHAPE_MS);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
